var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvertising(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.271,
    height: 23.713,
    viewBox: "0 0 30.271 23.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -55.467)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.063 55.467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.594,55.467a2.02,2.02,0,0,0-2.018,2.018v.365l-11.792,4.716a.506.506,0,0,0-.317.469V70.1a.5.5,0,0,0,.317.468l11.792,4.716v.365a2.018,2.018,0,0,0,4.036,0V57.485A2.02,2.02,0,0,0,133.594,55.467ZM134.6,75.648a1.009,1.009,0,1,1-2.018,0v-.706a.5.5,0,0,0-.317-.469l-11.791-4.716v-6.38l11.791-4.716a.505.505,0,0,0,.317-.469v-.706a1.009,1.009,0,0,1,2.018,0Z",
    transform: "translate(-119.467 -55.467)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 62.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.568,174.933H4.036a4.036,4.036,0,1,0,0,8.072H7.568a.5.5,0,0,0,.5-.5v-7.063A.5.5,0,0,0,7.568,174.933ZM7.063,182H4.036a3.027,3.027,0,1,1,0-6.054H7.063V182Z",
    transform: "translate(0 -174.933)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.199 63.539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.158,193.035l-3.027-1.009a.5.5,0,0,0-.664.479v5.045a.5.5,0,0,0,.5.5.5.5,0,0,0,.159-.026l3.027-1.009a.5.5,0,0,0,.345-.478v-3.027A.5.5,0,0,0,379.158,193.035Zm-.664,3.142-2.018.673V193.2l2.018.673Z",
    transform: "translate(-375.467 -192.001)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.027 69.594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.212,301.208l-.507-.507-1.48-5.918a.5.5,0,0,0-.489-.382H51.7a.5.5,0,0,0-.491.62l2.018,8.577a.505.505,0,0,0,.491.389.481.481,0,0,0,.1-.01l3.789-.732.015,0a1.216,1.216,0,0,0,.586-.32,1.211,1.211,0,0,0,.008-1.714Zm-.717,1a.2.2,0,0,1-.093.052l-3.3.638-1.761-7.485h3l1.419,5.672a.505.505,0,0,0,.133.235l.6.6a.2.2,0,0,1,.058.143A.2.2,0,0,1,57.495,302.2Z",
    transform: "translate(-51.195 -294.4)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.244 66.062)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.027,
    height: 1.009,
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.984 60.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.942,
    height: 1.009,
    transform: "translate(0 1.514) rotate(-30.972)",
    fill: "#0080ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.988 70.674)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.009,
    height: 2.942,
    transform: "translate(0 0.865) rotate(-59.036)",
    fill: "#0080ff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.172 57.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.009,
    height: 17.154,
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.045 64.548)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.009,
    height: 2.018,
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.027 64.548)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.009,
    height: 2.018,
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/advertising.25b517a7.svg";
export { ForwardRef as ReactComponent };